import React from 'react';
import config from "../../config";
import WebchatIcon from "../../assets/icons/platforms/WebchatIcon";
import WebchatMobileIcon from "../../assets/icons/platforms/WebchatMobileIcon";
import WhatsAppIcon from "../../assets/icons/platforms/WhatsAppIcon";
import ViberIcon from "../../assets/icons/platforms/ViberIcon";
import MessengerIcon from "../../assets/icons/platforms/MessengerIcon";
import TelegramIcon from "../../assets/icons/platforms/TelegramIcon";
import InstagramIcon from "../../assets/icons/platforms/InstagramIcon";
import WebexIcon from "../../assets/icons/platforms/WebexIcon";

/*
 * Which channel a conversation came in on.
 *
 * It was eight near-identical blocks, each testing one platform and each
 * drawing its own <img> inside its own <div>. A table instead, so a channel
 * added later is a line rather than a block.
 *
 * The two web chat icons are drawn rather than loaded: they are ours, they are
 * the same pair the bot testing buttons use, and as SVG they take the colour
 * around them and stay sharp at any size. The platform logos are drawn too now,
 * from the brand files the designer exported: sharp at any size, and they weigh
 * nothing next to six bitmaps. They keep their own colours - a brand mark is not
 * ours to restyle - so unlike our own icons they take no currentColor.
 */
/* every channel's mark, drawn - see the note above */
const PLATFORM_ICONS = {
    [config.platformsMap.whatsapp]: WhatsAppIcon,
    [config.platformsMap.viber]: ViberIcon,
    [config.platformsMap.messenger]: MessengerIcon,
    [config.platformsMap.telegram]: TelegramIcon,
    [config.platformsMap.instagram]: InstagramIcon,
    [config.platformsMap.webex]: WebexIcon,
};

const PlatformIcon = ({conversation, size, style = {}}) => {
    if (!conversation) return null;

    const {platform, fromMobile} = conversation;

    if (platform === config.platformsMap.webchat) {
        const Icon = fromMobile ? WebchatMobileIcon : WebchatIcon;
        return (
            <Icon
                width={size}
                height={size}
                strokeWidth={1.5}
                stroke="currentColor"
                style={{color: 'var(--ds-fg-tertiary)', ...style}}
            />
        );
    }

    const Icon = PLATFORM_ICONS[platform];
    if (!Icon) return null;

    return <Icon width={size} height={size} style={{...style}}/>;
};

export default PlatformIcon;



// WEBPACK FOOTER //
// ./src/components-new/general/PlatformIcon.jsx